


import React, { useState } from 'react';
import Vendorcoustomercare from "./Vendorcoustomercare";
import Usercoustomercare from "./Usercoustomercare";
import { Link } from "react-router-dom";
import DeliveryCare from "./DeliveryCare";
import "./VendorCare.css";
import InternalTickest from './InternalTickest';


function Foodcare() {
    const [activeView, setActiveView] = useState("user");

    // Style constants
    const activeColor = "rgb(230 109 51)";
    const inactiveColor = "#f0f2f5";
    const activeTextColor = "#ffffff";
    const inactiveTextColor = "#333333";
    const activeBorderColor = "rgb(230 109 51)";
    const inactiveBorderColor = "#ced4da";

    const commonButtonStyles = {
        padding: "0.5rem 0.5rem",
        borderRadius: "0.375rem",
        fontWeight: 600,
        borderWidth: "1px",
        borderStyle: "solid",
        cursor: "pointer",
        transition:
            "background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, color 0.15s ease-in-out",
        outline: "none",
        boxShadow: "none",
    };

    // Original margin for the container-fluid, potentially for a global page header or spacing.
    const pageWrapperMarginTopString = "15px";


    const contentEffectiveStartOffsetString = "80px"; // Using the original `topOffset` value


    const internalMarginTopValue =
        parseFloat(contentEffectiveStartOffsetString) - parseFloat(pageWrapperMarginTopString);
    const internalMarginTop = `${internalMarginTopValue}px`; // e.g., "30px"


    const mainFlexContainerHeight = `calc(100vh - ${contentEffectiveStartOffsetString})`;



    return (
        <div className="container-fluid p-0 care-data-managments-point" style={{ marginTop: '65px' }}>
            <div className="row">
                {/* <div className="col-lg-2"></div>  */}
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">


                    <div
                        style={{

                            marginTop: '15px', // Positions this block correctly within col-lg-10
                            height: mainFlexContainerHeight, // Ensures it fits the desired viewport portion
                        }}
                    >
                        {/* Button Bar Container */}
                        <div
                            className="d-flex justify-content-start row g-2" // Changed to left alignment
                            style={{
                                // padding: "1rem 0", // Adds vertical spacing around the buttons
                                backgroundColor: "#ffffff", // Crucial for sticky; content won't show through
                                flexShrink: 0, // Prevents this bar from shrinking if content is sparse
                                position: "sticky",
                                top: 0, // Sticks to the top of its parent (the Main Flex Container)
                                zIndex: 10,
                                marginLeft: "20px", // Ensures it stays above scrolling content
                                gap: "10px",
                                // borderBottom: '1px solid #e0e0e0', // Optional: if a visual separator is desired
                            }}
                        >

                            <button
                                type="button"
                                className="me-2 btn" // Bootstrap margin utility for spacing between buttons
                                style={{
                                    fontSize: "13px !important",
                                    width: "140px", // Fixed width for consistency
                                    ...commonButtonStyles,
                                    backgroundColor: activeView === "user" ? activeColor : inactiveColor,
                                    color: activeView === "user" ? activeTextColor : inactiveTextColor,
                                    borderColor: activeView === "user" ? activeBorderColor : inactiveBorderColor,
                                }}
                                onClick={() => setActiveView("user")}
                            >
                                User
                            </button>
                            <button
                                className="btn"
                                type="button"
                                style={{
                                    fontSize: "13px !important",
                                    width: "140px", // Fixed width for consistency
                                    ...commonButtonStyles,
                                    backgroundColor: activeView === "vendor" ? activeColor : inactiveColor,
                                    color: activeView === "vendor" ? activeTextColor : inactiveTextColor,
                                    borderColor: activeView === "vendor" ? activeBorderColor : inactiveBorderColor,
                                }}
                                onClick={() => setActiveView("vendor")}
                            >
                                Vendor
                            </button>
                            <button
                                className="btn"
                                type="button"
                                style={{
                                    fontSize: "13px !important",
                                    width: "140px", // Fixed width for consistency
                                    ...commonButtonStyles,
                                    backgroundColor: activeView === "rider" ? activeColor : inactiveColor,
                                    color: activeView === "rider" ? activeTextColor : inactiveTextColor,
                                    borderColor: activeView === "rider" ? activeBorderColor : inactiveBorderColor,
                                }}
                                onClick={() => setActiveView("rider")}
                            >
                                Riders
                            </button>
                            {/* <button
                                className="btn"
                                type="button"
                                style={{
                                    fontSize: "13px !important",
                                    width: "140px", // Fixed width for consistency
                                    ...commonButtonStyles,
                                    backgroundColor: activeView === "internal" ? activeColor : inactiveColor,
                                    color: activeView === "internal" ? activeTextColor : inactiveTextColor,
                                    borderColor: activeView === "internal" ? activeBorderColor : inactiveBorderColor,
                                }}
                                onClick={() => setActiveView("internal")}
                            >
                                Internal Tickets
                            </button> */}

                        </div>

                        {/* Scrollable Content Area */}
                        <div
                            style={{
                                flexGrow: 1,
                                height: "500px",
                                // maxWidth: '1280px',
                            }}
                            className='care-managment-data'
                        >
                            {activeView === "user" && <Usercoustomercare />}
                            {activeView === "vendor" && <Vendorcoustomercare />}
                            {activeView === "rider" && <DeliveryCare />}
                            {activeView === "internal" && <InternalTickest />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Foodcare;